import {Ticket} from '../types';
import {useTicketReply} from '../hooks/useTicketReply';
import {useTicketFeedback} from '../hooks/useTicketFeedback';
import {TicketHeader, TicketDeleteDialog} from './ticket/TicketHeader';
import {TicketMessage} from './ticket/TicketMessage';
import {DraftEditor} from './ticket/DraftEditor';

export const TicketDetail = ({ticket, onBack}: {ticket: Ticket; onBack: () => void}) => {
  const reply = useTicketReply(ticket);
  const feedback = useTicketFeedback(ticket);
  return <section className="ticket-detail" aria-label="Ticket and draft reply">
    <div className="ticket-detail-inner page-enter">
      <TicketHeader ticket={ticket} onBack={onBack} onDelete={() => reply.setDeleteOpen(true)}/>
      <TicketMessage ticket={ticket}/>
      <DraftEditor ticket={ticket} reply={reply} feedback={feedback}/>
    </div>
    <TicketDeleteDialog open={reply.deleteOpen} onOpenChange={reply.setDeleteOpen} onConfirm={reply.remove}/>
  </section>;
};